export const INSTAGRAM_URL = "https://instagram.com/220cordncode_official?igshid=YmMyMTA2M2Y=";
export const KAKAO_CHANNEL_URL = "http://pf.kakao.com/_xoPNxmb";
